window.SMTX.cookieConsent  = (function(){

  // var $_cookieConsent = $('#cookie_consent');
  // var _cookieConsentName = "cookie_consent_smtx_1.0";
  // var _cookieConsentAccept = "accept";

  // if( isAccepted() ){
  //   //window['ga-disable-UA-131209663-1'] = false;
  //   gtmConsentGiven();
  // }else{
  //   setTimeout(function(){
  //     $_cookieConsent.fadeIn(300);
  //   }, 650);

  // }

  // function gtmConsentGiven(){
  //   if( typeof dataLayer !== 'undefined'){
  //     //log('load analytics');
  //     dataLayer.push({'event': 'cookie_consent_given'});
  //   }else{
  //     log('Data layer is not defined, please implement Tag Manager');
  //   }
  // }

  // $(document).on('click', "a[data-accept-cookies]", function(){
  //   setCookie(_cookieConsentName, _cookieConsentAccept, 30);
  //   gtmConsentGiven();
  //   $_cookieConsent.fadeOut(300);
  // });

  // $(document).on('click', "a[data-refuse-cookies]", function(){
  //   $_cookieConsent.fadeOut(300);
  // });

  // function isAccepted(){
  //   return true;
  //   //return getCookie(_cookieConsentName) !== null;
  // }

  // function setCookie(cname, cvalue, exdays) {
  //   var d = new Date();
  //   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  //   var expires = "expires="+d.toUTCString();
  //   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  // }

  // function getCookie(cname) {
  //   var name = cname + "=";
  //   var ca = document.cookie.split(';');
  //   for(var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == ' ') {
  //       c = c.substring(1);
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length);
  //     }
  //   }
  //   return null;
  // }

  // return {

  // };

})();
